<template>
  <v-dialog v-model="show" persistent max-width="640">
    <v-card width="800" style="padding: 24px;">
      <div
        class="d-flex justify-space-between">
        <span
          :class="`${defaultColor}--text font-weight-bold`"
          style="font-weight: 18px;">
          Exportar Relatório
        </span>

        <v-icon @click="hideModal()">
          mdi-close
        </v-icon>
      </div>

      <div
        style="padding-top: 24px;">
        <v-text-field
          value="Relatório Posição Cadastral"
          readonly
          outlined
        />
      </div>

      <div
        class="d-flex justify-end"
        style="padding-top: 24px;">
        <v-btn
          class="mr-2"
          outlined
          :color="defaultColor"
          style="height: 50px; width: 160px; border-radius: 10px;"
          @click="hideModal()">
          Cancelar
        </v-btn>

        <v-btn
          class="ml-2"
          :color="defaultColor"
          style="height: 50px; width: 160px; border-radius: 10px;"
          @click="requestExport()">
          Enviar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ExportModal",
  data: () => ({
    show: false,
  }),

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    defaultColor: {
      type: String,
      default: 'primary'
    },
  },

  watch: {
    showModal: {
      handler(show) {
        this.show = show;
      }
    }
  },

  methods: {
    requestExport() {
      this.$emit('requestExport')
    },
    hideModal() {
      this.$emit('hideModal')
    }
  }
}
</script>